var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scheduleTime)?_c('div',[_c('strong',[_vm._v("ส่งข้อความตามไปในเวลา")]),_vm._v(" "),(_vm.scheduleTime.HH != '00')?[_vm._v(_vm._s(_vm.scheduleTime.HH)+" ชั่วโมง")]:_vm._e(),_vm._v(" "),(_vm.scheduleTime.mm != '00')?[_vm._v(_vm._s(_vm.scheduleTime.mm)+" นาที")]:_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5915d2c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/generalixwarroom/FollowupMessageScheduleDetail.vue
// module id = null
// module chunks = 